import React from 'react';
import { Select } from 'antd';
import Icon from '@mdi/react';
import Ninja from '@ninja';
import { eventTypeMap } from 'components/icons/EventTypeIcons';

const { Option } = Select;

const EventTypeSelector = (props) => {
  const { value, onChange, placeholder = 'Select Event Type' } = props;
  return (
    <Select
      className='w-full'
      mode='multiple'
      maxTagCount='responsive'
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      allowClear
      {...props}
    >
      {Object.entries(eventTypeMap).map(([key, { title, icon }]) => (
        <Option key={key} value={key} label={title}>
          <div className='flex align-center gap-2 text-xs'>
            <Icon path={icon} size={0.7} color={Ninja.colors.info} className='flex items-center' />
            <span>{title}</span>
          </div>
        </Option>
      ))}
    </Select>
  );
};

export default EventTypeSelector;
